import { useFormikContext } from "formik";
import { FormEnums } from "models/enums";
import { GenericFormField, GenericFormSection } from "models/propTypes/genericFormProps";

function useCheckHasErrors<T extends Record<string, any>>(checkInitialErrors?: boolean) {
  const { touched, errors } = useFormikContext<T>();

  const getHasErrors = (
    item: GenericFormField<T> | GenericFormSection<T>,
    name?: string,
    arrayKey?: string
  ): boolean => {
    if (item)
      if (
        item.type !== FormEnums.FormFieldType.EDITABLETABLE &&
        item.type !== FormEnums.FormFieldType.FORMFIELDSELECTOR &&
        item.innerFields !== undefined
      ) {
        const innerObj = Array.isArray(item.innerFields)
          ? (item.innerFields as any).map((innerField: GenericFormSection<T>) => getHasErrors(innerField))
          : Object.entries(item.innerFields).map(
              ([key, innerField]) => innerField && getHasErrors(innerField, key, arrayKey)
            );

        return innerObj.some((hasErrors: boolean) => hasErrors);
      } else {
        let fieldErrors;
        if (arrayKey) {
          const arrayErrors = errors[arrayKey];
          fieldErrors =
            name &&
            (checkInitialErrors || touched[arrayKey]) &&
            arrayErrors &&
            Object.values(arrayErrors).some((value) => value && value[name]);
        } else fieldErrors = name && (checkInitialErrors || touched[name]) && errors[name];

        return !!fieldErrors;
      }
    else return false;
  };

  return {
    getHasErrors,
  };
}

export default useCheckHasErrors;
